import axios from "./axios-auth";

const insertProduct = (payload) =>
  new Promise((resolve, reject) => {
    axios({
      url: "/dv-adm/addProducts",
      data: payload,
      method: "POST",
    })
      .then((resp) => {
        console.log(resp, " from insert product api");
        if (resp.status !== 200){
          throw new Error(resp.data.message);
        }
        resolve(resp.data);
      })
      .catch((err) => {
        alert(err);
      });
  });

const getProductById = (params) =>
  new Promise((resolve, reject) => {
    axios({
      url: "/dv-adm/getproductbyid",
      params: params,
      method: "GET",
    })
      .then((resp) => {
        console.log(resp, "get product by id api");
        resolve(resp.data);
      })
      .catch(() => {
        console.log("error from get product by id api");
      });
  });

const editProduct = (payload) =>
  new Promise((resolve, reject) => {
    axios({
      url: "/dv-adm/updateproductbyid",
      data: payload,
      method: "PUT",
    })
      .then((resp) => {
        console.log(resp, " from edit product api");
        resolve(resp.data);
      })
      .catch((err) => {
        console.log(err, "from edit product api");
      });
  });

const deleteProduct = (params) =>
  new Promise((resolve, reject) => {
    axios({
      url: "/dv-adm/deleteproductbyid",
      params: params,
      method: "DELETE",
    })
      .then((resp) => {
        console.log(resp, " from deleteProduct api");
        resolve(resp.data);
      })
      .catch((err) => {
        console.log(err, "from deleteProduct api");
      });
  });

const getAllProducts = (data) =>
  new Promise((resolve, reject) => {
    axios({
      url: "/dv-adm/getallproducts",
      params: {},
      data: data,
      method: "POST",
    })
      .then((resp) => {
        console.log(resp, "resp from getAllProducts api");
        resolve(resp);
      })
      .catch(() => {
        console.log("error from from getAllProducts api");
      });
  });

const addProductImage = (formData) =>
  new Promise((resolve, reject) => {
    axios({
      url: "/dv-adm/uploadimage",
      data: formData,
      method: "POST",
      headers: { "Content-Type": "multipart/form-data" },
    })
      .then((resp) => {
        resolve(resp.status);
      })
      .catch(() => {
        console.log("error from upload product image api");
      });
  });

export {
  insertProduct,
  getProductById,
  editProduct,
  deleteProduct,
  getAllProducts,
  addProductImage,
};
